var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00024 3.00003C2.00024 2.44775 2.44796 2.00003 3.00024 2.00003H10.0002C10.5525 2.00003 11.0002 2.44775 11.0002 3.00003V10C11.0002 10.5523 10.5525 11 10.0002 11H3.00024C2.44796 11 2.00024 10.5523 2.00024 10V3.00003ZM4.00024 4.00003V9.00003H9.00024V4.00003H4.00024ZM13.0002 3.00003C13.0002 2.44775 13.448 2.00003 14.0002 2.00003H21.0002C21.5525 2.00003 22.0002 2.44775 22.0002 3.00003V10C22.0002 10.5523 21.5525 11 21.0002 11H14.0002C13.448 11 13.0002 10.5523 13.0002 10V3.00003ZM15.0002 4.00003V9.00003H20.0002V4.00003H15.0002ZM2.00024 14C2.00024 13.4477 2.44796 13 3.00024 13H10.0002C10.5525 13 11.0002 13.4477 11.0002 14V21C11.0002 21.5523 10.5525 22 10.0002 22H3.00024C2.44796 22 2.00024 21.5523 2.00024 21V14ZM4.00024 15V20H9.00024V15H4.00024ZM13.0002 14C13.0002 13.4477 13.448 13 14.0002 13H21.0002C21.5525 13 22.0002 13.4477 22.0002 14V21C22.0002 21.5523 21.5525 22 21.0002 22H14.0002C13.448 22 13.0002 21.5523 13.0002 21V14ZM15.0002 15V20H20.0002V15H15.0002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.256cc1d7190a4819c18849fbb2a62467.svg";
export { ForwardRef as ReactComponent };